import React from "react";
import { ShieldAlert, Gauge, GraduationCap } from "lucide-react";

const MODES = [
  { id: "standard", label: "Standard", icon: Gauge },
  { id: "code", label: "Code", icon: ShieldAlert },
  { id: "preceptor", label: "Preceptor", icon: GraduationCap },
];

export default function ModeSwitcher({ mode, onChange, disabled }) {
  return (
    <div
      className="inline-flex items-center border border-[#e4ded2] bg-[#fbf8f2] rounded-sm overflow-hidden"
      data-testid="mode-switcher"
    >
      {MODES.map((m) => {
        const Icon = m.icon;
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            disabled={disabled}
            onClick={() => onChange(m.id)}
            data-testid={`mode-btn-${m.id}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs uppercase tracking-widest font-medium transition-colors ${
              active
                ? "bg-[#6f2a30] text-[#f1eee7]"
                : "bg-[#fbf8f2] text-[#6b6258] hover:bg-[#f1eee7]"
            } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={1.5} />
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
